import React from 'react';
import { Stack, Typography } from '@mui/material';
import TaxiAlertIcon from '@mui/icons-material/TaxiAlert';

const SearchNoData = () => {
    return (
        <Stack alignItems='center' >
            <TaxiAlertIcon className='h-20 w-20 py-4  text-light-border' />
            <Typography variant='body1' className='w-full text-center text-border py-2'>NO DATA</Typography>
        </Stack>
    );
};

export default SearchNoData;
